import { Box, EmptyState, SelectionList, Text } from '@dixa/lib-shared-habla';
import { Satisfaction } from 'lib-shared-legacy-types';
import { PropsWithClassName } from 'lib-shared-types-utils';
import { Control } from 'react-hook-form';

import { ratingApi } from 'apis/rating';
import { FieldValues } from 'app/views/layout/views/settings/views/satisfaction/survey/components/select/selectSurveyModal';
import { HookFormSelectionListSingle } from 'components/hookForm';

import styles from './surveySelect.module.scss';

export type SurveySelectProps = {
  surveyType: Satisfaction.SurveyType;
  control: Control<FieldValues>;
} & PropsWithClassName;

/** Represents the component for selecting a survey. */
export const SurveySelect = ({
  surveyType,
  control,
}: SurveySelectProps): JSX.Element => {
  const { surveys, isSuccess } = ratingApi.useReadRatingSettingsQuery(
    {
      level: 'survey',
      surveyType: surveyType,
    },
    {
      selectFromResult: ({ data, ...rest }) => ({
        ...rest,
        surveys: data?.data.rating_settings,
      }),
    },
  );

  return (
    <HookFormSelectionListSingle
      name="selectedSurvey"
      label="CSAT survey"
      disabled={!isSuccess}
      control={control}
      noAlert={true}
      componentProps={{
        getItemTitleByValue: (
          survey: Satisfaction.CsatSettings | null | undefined,
        ) => survey?.name ?? '-',
        placeholder: 'Select a survey',
        className: styles.inputSelectionDropdown,
      }}
      rules={{
        required: 'CSAT survey is required',
        validate: (value) => !!value?.id || 'CSAT survey is required',
      }}
    >
      {surveys?.map((survey) => {
        return (
          <SelectionList.Item key={survey.id} value={survey}>
            <Text.Paragraph>{survey.name}</Text.Paragraph>
          </SelectionList.Item>
        );
      })}

      {!surveys?.length && (
        <Box as="li" padding="300">
          <EmptyState
            title="No surveys found"
            description="Try changing your search criteria."
          />
        </Box>
      )}
    </HookFormSelectionListSingle>
  );
};
